import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { SaveFeedback } from './SaveFeedback';
import { SettingsTabs } from './SettingsTabs';

const DESKTOP = 'md';

export function SettingsLayout(): ReactElement {
    const { t } = useTranslation();

    return (
        <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: { xs: 2, [DESKTOP]: 3 } }}>
            <Stack spacing={2}>
                <Typography variant="h5" component="h1" sx={{ pt: 1 }}>
                    {t('SETTINGS.TITLE')}
                </Typography>
                <SettingsTabs />
            </Stack>

            <Box component="section" sx={{ py: 2 }}>
                <Outlet />
            </Box>

            <SaveFeedback />
        </Box>
    );
}
